<template>
  <basic-container>
    <div
      class="path-container"
      style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>家庭医生工作站</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>药物推荐</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="margin-top: 50px">
      <div style="font-size: 20px; margin-top: 10px; margin-bottom: 10px">
        药物方案
      </div>
      <avue-crud
        :option="option1"
        :data="drug"
        :page.sync="page1"
        v-model="drugForm"
        :permission="permissionList"
        @row-del="rowDel1"
        @row-update="rowUpdate1"
        @row-save="rowSave1"
        :before-open="beforeOpen1"
        @on-load="onLoad"
        :header-cell-class-name="headerCellClassName"
      >
      </avue-crud>
    </div>
  </basic-container>
</template>

<script>
import { getQa } from "@/api/health/manage";
import { mapGetters } from "vuex";
import {
  getDurg,
  getListUDP,
  getDetailUDP,
  removeUDP,
  submitUDP,
} from "@/api/health/plan_details";
import { getList } from "@/api/health/archiveType";

export default {
  data() {
    return {
      form: {},
      form0: {},
      drugForm: {},
      data: [],
      files: [],
      drug: [],
      wxUserId: 0,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      page1: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      page2: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      headerCellClassName: 'headerClass',
      option1: {
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        addBtn: true,
        menuWidth: 200,
        column: [
          {
            type: "tree",
            label: "选择药品 ",
            prop: "ssProvince",
            span: 24,
            hide: true,
            addDisplay: true,
            editDisabled: false,
            dicUrl: "https://dbadmin.dbzdjk.com/admin/fy/rest/third/DmTest",
            dicMethod: "post",
            props: {
              label: "name",
              value: "code",
            },
            slot: true,
            nodeClick: (data) => {
              getDurg(data.code).then((res) => {
                const data1 = res.data;
                this.drugForm.drugName = data1.drugName;
                this.drugForm.tradeName = data1.tradeName;
                this.drugForm.indications = data1.indications;
                this.drugForm.dosageTaken = data1.dosageTaken;
                this.drugForm.medicationFrequency = data1.medicationFrequency;
                this.drugForm.medicationTime = data1.medicationTime;
                this.drugForm.note = data1.note;
              });
            },
          },
          {
            label: "药品名称",
            prop: "drugName",
            span: 24,
            cell: true,
            rules: [
              {
                required: true,
                message: "请输入药品名称",
              },
            ],
          },
          {
            label: "商品名称",
            prop: "tradeName",
            span: 24,
            cell: true,
            rules: [
              {
                required: true,
                message: "请输入商品名称",
              },
            ],
          },
          {
            label: "适用症状",
            prop: "indications",
            span: 24,
            cell: true,
            rules: [
              {
                required: true,
                message: "请输入药品名称",
              },
            ],
          },
          {
            label: "服用剂量",
            prop: "dosageTaken",
            span: 24,
            cell: true,
            rules: [
              {
                required: true,
                message: "请输入服用剂量",
              },
            ],
          },
          {
            label: "服用频次",
            prop: "medicationFrequency",
            span: 24,
            cell: true,
            rules: [
              {
                required: true,
                message: "请输入服用频次",
              },
            ],
          },
          {
            label: "服用时间",
            prop: "medicationTime",
            span: 24,
            cell: true,
            rules: [
              {
                required: true,
                message: "请输入服用时间",
              },
            ],
          },
          {
            label: "注意事项",
            prop: "note",
            span: 24,
            cell: true,
            rules: [
              {
                required: false,
                message: "请输入注意事项",
              },
            ],
          },
          {
            label: "创建时间",
            prop: "createTime",
            addDisplay: false,
            editDisabled: true,
            span: 24,
            hide: true,
            cell: false,
          },
          {
            label: "修改时间",
            prop: "updateTime",
            addDisplay: false,
            editDisabled: true,
            span: 24,
            hide: true,
            cell: false,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.permission.qa_qa_add,
        viewBtn: this.permission.qa_qa_view,
        delBtn: this.permission.qa_qa_delete,
        editBtn: this.permission.qa_qa_edit,
      };
    },
    ids() {
      const ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  created() {
    this.wxUserId = this.$route.query.wxUserId;
  },
  methods: {
    onLoad(page, params = { id: this.wxUserId }) {
      const wxUserId = this.$route.query.wxUserId;
      getQa(wxUserId).then((res) => {
        console.log("getQa?", res.data);
        this.data = res.data;
      });
      // getDigitalArchives(wxUserId).then((res) => {
      //   this.data = res.data;
      // });
      getList(page.currentPage, page.pageSize, params).then((res) => {
        console.log(res.data);
        this.files = res.data;
      });
      getListUDP(this.wxUserId).then((res) => {
        const data1 = res.data.records;
        this.page2.total1 = data1.total;
        this.drug = data1;
      });
    },

    toItemModify(row) {
      this.$router.push({
        path: "/doctor/archiveTypeDetails",
        query: {
          wxUserId: this.wxUserId,
          type: row.type,
        },
      });
    },

    toItemModify2(row) {
      this.$router.push({
        path: "/doctor/questionnaire",
        query: {
          wxUserId: this.wxUserId,
          qaId: row.id,
          qaName: row.name
        },
      });
    },

    beforeOpen1(done, type) {
      console.log(this.drugForm);
      if (["edit", "view"].includes(type)) {
        getDetailUDP(this.drugForm.id).then((res) => {
          this.drugForm = res.data;
        });
      }
      done();
    },

    rowSave1(row, done, loading) {
      row.isUsing = "1";
      row.wxUserId = this.wxUserId;
      submitUDP(row)
        .then(() => {
          done();
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        })
        .catch(() => {
          loading();
        });
    },

    rowUpdate1(row, index, done, loading) {
      row.wxUserId = this.wxUserId;
      submitUDP(row)
        .then(() => {
          done();
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        })
        .catch(() => {
          loading();
        });
    },

    rowDel1(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return removeUDP(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },
  },
};
</script>
<style scoped>
.headerClass{
      background-color: #409EFF !important;
      color:#FFF !important;
    }
</style>
